class NewsletterBoxController {
    /*@ngInject*/
    constructor($log, $rootScope, CommonService) {
        $log.debug('NewsletterBoxController initialized');
        this.requestPending = false;
        this.hasFashionNewsletter = false;
        this.commonService = CommonService;

        this.selectedCountry = '';
        this.country = {
            selected: null
        };
        if (window.fashionNewsletterCountries) {
            this.countries = window.fashionNewsletterCountries.countries;
        }

        $rootScope.$on('personalizeRequestSuccess', () => {
            this.hasFashionNewsletter = this.commonService.getPersonalizeRequestResponse().hasFashionNewsletter;
        });
    }

    submit(form) {
        this.requestPending = true;
        form.$$element.submit();
    }

    countryChanged(item) {
        this.selectedCountry = item.code;
    }

    setCountryCode(code) {
        if (code) {
            this.selectedCountry = code;
            for (let entry of this.countries) {
                if (code === entry.code) {
                    this.country.selected = entry;
                    break;
                }
            }
        }
    }
}

export default NewsletterBoxController;
